import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function PortfolioSection() {
  return <section className="py-24 px-4 bg-dark-800 relative border-y border-gold/10" data-id="element-81">
      <div className="max-w-7xl mx-auto" data-id="element-82">
        <div className="text-center mb-16" data-id="element-83">
          <h2 className="font-serif text-3xl md:text-5xl text-white mb-4" data-id="element-84">
            The Killshot Effect
          </h2>
          <p className="font-sans text-gold text-lg md:text-xl" data-id="element-85">
            Transformaciones Digitales que Hablan por Sí Solas
          </p>
        </div>

        <div className="space-y-16" data-id="element-86">
          {/* Transformation Card 1 */}
          <div className="flex flex-col lg:flex-row gap-4 lg:gap-8 items-center" data-id="element-87">
            {/* Before */}
            <div className="w-full lg:w-1/2 bg-dark-700 rounded-sm border border-gray-800 overflow-hidden relative group" data-id="element-88">
              <div className="absolute top-4 left-4 bg-gray-800 text-gray-300 text-xs font-bold px-3 py-1 rounded-sm z-10 uppercase tracking-wider" data-id="element-89">
                Antes: Plantilla Genérica
              </div>
              <div className="aspect-video bg-gray-900 flex flex-col items-center justify-center p-8 opacity-60 grayscale" data-id="element-90">
                <img src="https://cdn.magicpatterns.com/uploads/bYzd6CSXFGvHPqc3jAn4ue/WhatsApp_Image_2026-03-27_at_5.19.01_PM.jpg" alt="Antes: Plantilla Genérica" className="absolute inset-0 w-full h-full object-cover" data-id="element-91" />
              </div>
            </div>

            {/* Arrow Indicator (Desktop) / Down Arrow (Mobile) */}
            <div className="hidden lg:flex items-center justify-center w-12 h-12 rounded-full bg-dark-900 border border-gold text-gold shrink-0 z-10 shadow-[0_0_15px_rgba(212,175,55,0.2)]" data-id="element-92">
              <ChevronRightIcon className="w-6 h-6" data-id="element-93" />
            </div>
            <div className="lg:hidden flex items-center justify-center w-10 h-10 rounded-full bg-dark-900 border border-gold text-gold shrink-0 z-10 shadow-[0_0_15px_rgba(212,175,55,0.2)] rotate-90 my-2" data-id="element-94">
              <ChevronRightIcon className="w-5 h-5" data-id="element-95" />
            </div>

            {/* After */}
            <div className="w-full lg:w-1/2 bg-dark-900 rounded-sm border border-gold/40 overflow-hidden relative shadow-[0_0_30px_rgba(212,175,55,0.1)] group" data-id="element-96">
              <div className="absolute top-4 left-4 bg-gradient-to-r from-gold to-gold-dark text-black text-xs font-bold px-3 py-1 rounded-sm z-10 uppercase tracking-wider shadow-lg" data-id="element-97">
                Después: Experiencia Killshot
              </div>
              <div className="aspect-video bg-dark-900 flex flex-col items-center justify-center p-8 relative overflow-hidden" data-id="element-98">
                {/* Decorative background elements */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 blur-3xl rounded-full" data-id="element-99"></div>
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-gold/5 blur-3xl rounded-full" data-id="element-100"></div>

                <img src="https://cdn.magicpatterns.com/uploads/3x1pX4zQixNDBPbonKj52i/gemini-2.5-flash-image_Replace_the_image_on_that_webpage—within_the_tablet_display—with_the_other_i-0_(1).jpg" alt="Después: Experiencia Killshot" className="absolute inset-0 w-full h-full object-cover z-10" data-id="element-101" />
              </div>
            </div>
          </div>

          {/* Transformation Card 2 */}
          <div className="flex flex-col lg:flex-row gap-4 lg:gap-8 items-center" data-id="element-102">
            {/* Before */}
            <div className="w-full lg:w-1/2 bg-dark-700 rounded-sm border border-gray-800 overflow-hidden relative group" data-id="element-103">
              <div className="absolute top-4 left-4 bg-gray-800 text-gray-300 text-xs font-bold px-3 py-1 rounded-sm z-10 uppercase tracking-wider" data-id="element-104">
                Antes: Plantilla Genérica
              </div>
              <div className="aspect-video bg-gray-900 opacity-60 grayscale overflow-hidden" data-id="element-105">
                <img src="https://cdn.magicpatterns.com/uploads/hMGDzJe1EmmeE9G76625J3/nano-banana-2_Replace_the_image_on_that_webpage—within_the_tablet_display—with_the_other_i-0.jpg" alt="Antes: Plantilla Genérica" className="w-full h-full object-cover" data-id="element-106" />
              </div>
            </div>

            {/* Arrow Indicator */}
            <div className="hidden lg:flex items-center justify-center w-12 h-12 rounded-full bg-dark-900 border border-gold text-gold shrink-0 z-10 shadow-[0_0_15px_rgba(212,175,55,0.2)]" data-id="element-107">
              <ChevronRightIcon className="w-6 h-6" data-id="element-108" />
            </div>
            <div className="lg:hidden flex items-center justify-center w-10 h-10 rounded-full bg-dark-900 border border-gold text-gold shrink-0 z-10 shadow-[0_0_15px_rgba(212,175,55,0.2)] rotate-90 my-2" data-id="element-109">
              <ChevronRightIcon className="w-5 h-5" data-id="element-110" />
            </div>

            {/* After */}
            <div className="w-full lg:w-1/2 bg-dark-900 rounded-sm border border-gold/40 overflow-hidden relative shadow-[0_0_30px_rgba(212,175,55,0.1)] group" data-id="element-111">
              <div className="absolute top-4 left-4 bg-gradient-to-r from-gold to-gold-dark text-black text-xs font-bold px-3 py-1 rounded-sm z-10 uppercase tracking-wider shadow-lg" data-id="element-112">
                Después: Experiencia Killshot
              </div>
              <div className="aspect-video bg-dark-900 relative overflow-hidden" data-id="element-113">
                <div className="absolute inset-0 bg-gradient-radial from-gold/5 to-transparent z-10 pointer-events-none" data-id="element-114"></div>
                <video src="https://cdn.magicpatterns.com/uploads/h4rRiaBfxmgmafZh5v2TuJ/kling-3.0_Cinematic_slow_zoom-in_towards_the_tablet_screen._The_screen_displays_a_premium_-0.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover relative z-0" data-id="element-115" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}